/**
 * return-form.js — xConnector returns/withdrawal iframe embed.
 * Reads window.Shopify.shop + window.xConnector.token (defined in theme.liquid),
 * injects the app iframe, and auto-resizes it from the app's postMessage events.
 * Only trusts messages from the app origin, and never throws on foreign messages.
 */
(() => {
  const holder = document.getElementById('return-request-holder');
  const shop = window.Shopify?.shop;
  const token = window.xConnector?.token;
  if (!holder || !shop || !token) return;

  const APP_ORIGIN = 'https://return.xconnector.app';
  const language = window.Shopify?.locale || document.documentElement.lang || '';
  const iframe = Object.assign(document.createElement('iframe'), {
    id: 'return-request-holder-iframe',
    src: `${APP_ORIGIN}?shop=${encodeURIComponent(shop)}&token=${encodeURIComponent(token)}&default-language=${encodeURIComponent(language)}`,
    scrolling: 'no',
  });
  iframe.style.cssText = 'border:none;width:100%';
  holder.append(iframe);

  window.addEventListener('message', (event) => {
    if (event.origin !== APP_ORIGIN) return;
    let payload;
    try {
      payload = JSON.parse(event.data);
    } catch {
      return;
    }
    if (payload?.type === 'resize') iframe.height = payload.data?.height ?? iframe.height;
  });
})();
